<!--

  Created: 2026-01-27

  When upgrading this map to use google maps AdvancedMarkerElement I encountered some errors
  when shifting the page from debug env into the main application. Apparently the way that
  google mpas works is that these html elements are rendering inside google maps before
  displaying, so I tried re-setting various things and still struggled with getting them to
  render.

The problem was solved in several ways.

1) Use gmp-click for listening to clicks on the advanced markler

        advancedMarkerElement.addListener('gmp-click', () => {
          this.togglehighlight(advancedMarkerElement, veh)
        })

2) The css relies on a routine called togglehighlight() which works as follows:

    togglehighlight (markerView, property) {
      if (markerView.content.classList.contains('highlight-veh-marker-2026')) {
        markerView.content.classList.remove('highlight-veh-marker-2026')
        markerView.zIndex = null
      }
      else {
        markerView.content.classList.add('highlight-veh-marker-2026')
        markerView.zIndex = 1
      }
    },

   This routine essential activates and adds styling to the marker so that the marker
  will be visible, and removes it by setting the zIndex to null

3) I used a unique name: 'property-veh-marker-2026' it is possible that previsoluly because
    I was using just property as a name, this was interfering with stylingh or being interfered
    with by global css declarations, I also used a unique name for the highlight which is what
   appears when the user clicks on the icon: highlight-veh-marker-2026

4) Finally I had to make sure that the detail was hidden and modifed the css below to do that

    .property-veh-marker-2026 .details {
        display: none;  /* making this none was mui importante because otherwise the deatils appeared on map without click */
        flex-direction: column;
        flex: 1;
     }

-->
 <!--
  History
      0.1 - 2026-02-09
        - modified to remove trip button options and added

      0.2 -2026-03-02
        - Added a timer to the click event on the marker, this is because when clicking on the marker, the click event
          was immediatly trigger the follow button on the marker when clicked on a mobile device

     -->

<template>
  <v-container>
    <div id="map" :style="mapStyle"></div>

    <v-row>
      <v-col cols="auto">
        <v-progress-circular v-show="isLoading"
                             class="progress-overlay"
                             indeterminate
                             size="120"
                             width="15"
                             color="primary" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-multiple-empty-lines */

//
// Below is used for debugging the page withouth need for the database being online.
//
import { format } from 'date-fns'; function getFormattedDateTime () {
  const now = new Date()

  const year = now.getFullYear()
  // getMonth() is zero-based (0 for January), so add 1
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')

  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
}

//
// Below is used for debugging the page withouth need for the database being online.
//

var test_vehs = [{
  AccessCount: 0,
  Active: 1,
  CarBattery: 12.685,
  ChassisNumber: null,
  ClientID: 3406,
  ClientName: 'Atmei',
  Colour: 'Silver',
  CompanyName: 'Atmei Construction',
  DEALER: 'Construction',
  DefaultTripType: 1,
  Description: 'TEST_1',
  DriverID: null,
  DriverName: 'N/A',
  Exists: false,
  Firmware: null,
  ID: 16689,
  IgnitionStatus: 1,
  InceptionDate: '2019/09/09',
  InternalBattery: 3.957,
  LastUpdate: getFormattedDateTime(),
  Latitude: -26.1363964080811,
  lcase_CompanyName: 'atmei construction',
  lcase_RegNumber: 'xdk485gp',
  lcase_UnitID: '358480089001426',
  Longitude: 27.6240732574463,
  MSISDN: '27797523066',
  RegNumber: 'TEST_1',
  SpecialFeatures: ' ',
  Speed: 0.0,
  StockNumber: 'N/A',
  TenantCode: 'RAPTOR',
  UnitID: '358480089001426',
  UnitModel: 'Teltonika 920',
  UnitModel2ID: 33,
  UnitState: 3,
  UnitTypeName: 'Eagle',
  UserVehicleColour: 'Silver',
  UserVehicleMake: 'Isuzu               ',
  UserVehicleModel: 'KB Series',
  VehicleColour: null,
  VehicleDetailsZone: null,
  VehicleMake: 'Isuzu               ',
  VehicleModel: 'KB Series',
  Version: 24429,
  VIN: 'ADM2RP86B73455548'
},

{
  AccessCount: 0,
  Active: 0,
  CarBattery: 12.685,
  ChassisNumber: null,
  ClientID: 3406,
  ClientName: 'Atmei',
  Colour: 'Silver',
  CompanyName: 'Atmei Construction',
  DEALER: 'Construction',
  DefaultTripType: 1,
  Description: 'STAT_XDK485GP',
  DriverID: null,
  DriverName: 'N/A',
  Exists: false,
  Firmware: null,
  ID: 16689,
  IgnitionStatus: 0,
  InceptionDate: '2019/09/09',
  InternalBattery: 3.957,
  LastUpdate: getFormattedDateTime(),
  Latitude: -26.1363964080811,
  lcase_CompanyName: 'atmei construction',
  lcase_RegNumber: 'xdk485gp',
  lcase_UnitID: '358480089001426',
  Longitude: 27.6340732574463,
  MSISDN: '27797523066',
  RegNumber: 'TEST_2',
  SpecialFeatures: ' ',
  Speed: 0.0,
  StockNumber: 'N/A',
  TenantCode: 'RAPTOR',
  UnitID: '358480089001426',
  UnitModel: 'Teltonika 920',
  UnitModel2ID: 33,
  UnitState: 3,
  UnitTypeName: 'Eagle',
  UserVehicleColour: 'Silver',
  UserVehicleMake: 'Isuzu               ',
  UserVehicleModel: 'KB Series',
  VehicleColour: null,
  VehicleDetailsZone: null,
  VehicleMake: 'Isuzu               ',
  VehicleModel: 'KB Series',
  Version: 24429,
  VIN: 'ADM2RP86B73455548'
},

{
  AccessCount: 0,
  Active: 0,
  CarBattery: 12.685,
  ChassisNumber: null,
  ClientID: 3406,
  ClientName: 'Atmei',
  Colour: 'Silver',
  CompanyName: 'Atmei Construction',
  DEALER: 'Construction',
  DefaultTripType: 1,
  Description: 'STAT_XDK485GP',
  DriverID: null,
  DriverName: 'N/A',
  Exists: false,
  Firmware: null,
  ID: 16689,
  IgnitionStatus: 0,
  InceptionDate: '2019/09/09',
  InternalBattery: 3.957,
  LastUpdate: '2026/01/14 14:57:06',
  Latitude: -26.1363964080811,
  lcase_CompanyName: 'atmei construction',
  lcase_RegNumber: 'xdk485gp',
  lcase_UnitID: '358480089001426',
  Longitude: 27.6540732574463,
  MSISDN: '27797523066',
  RegNumber: 'TEST_3',
  SpecialFeatures: ' ',
  Speed: 0.0,
  StockNumber: 'N/A',
  TenantCode: 'RAPTOR',
  UnitID: '358480089001426',
  UnitModel: 'Teltonika 920',
  UnitModel2ID: 33,
  UnitState: 3,
  UnitTypeName: 'Eagle',
  UserVehicleColour: 'Silver',
  UserVehicleMake: 'Isuzu               ',
  UserVehicleModel: 'KB Series',
  VehicleColour: null,
  VehicleDetailsZone: null,
  VehicleMake: 'Isuzu               ',
  VehicleModel: 'KB Series',
  Version: 24429,
  VIN: 'ADM2RP86B73455548'
}
]

const TIME_AMBER_STATIONARY_HRS = 30

export default {
  data () {
    return {
      // 2026-02-09 -
      //   added so that should we wish we can display buttons for
      //   the vehicle
      tripButtons: false,
      isLoading: false,

      mapStyle: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100vw',
        /// -----------------------------------------------------------
        /// 2025-03-18
        ///   - changed apple device from 90dvh &  93 dvh to 91dvh and 94dvh
        /// -----------------------------------------------------------
        height: this.isAppleDevice() ? '91dvh' : '94dvh'
      },
      //
      vehicles: test_vehs,
      baseTime: new Date(),
      minutesOffset: 0, // 0 = start time, 1500 = +25 hours

      sliderValues: [300, 900],
      StartTime: '',
      EndTime: '',
      map: null,
      markers: [] // store all markers so we can clean up if needed
    }
  },

  mounted () {
    this.fetchLive()
    // this.fetchData()
  },


  created () {
    this.baseTime.setSeconds(0, 0)
  },

  computed: {
    isoDateTime () {
      const date = new Date(this.baseTime)
      date.setMinutes(date.getMinutes() + this.minutesOffset)
      return date.toISOString()
    }
  },

  methods: {

    initMap () {
      this.map = new google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        center: { lat: -26, lng: 27 },
        mapTypeId: 'roadmap',
        mapId: 'b00531e667bdc68a',
        mapTypeControl: true, // Disables the Satellite button
        streetViewControl: false // This disables the Pegman control

      })
    },

    zoomCoOrdinates () {
      const bounds = new google.maps.LatLngBounds()

      this.markers.forEach((marker, index) => {
        try {
          var lat = this.checkNull(marker.position.lat, 'dd')
          var lon = this.checkNull(marker.position.lng, 'dd')

          if ((lat === 0) || (lon === 0)) {
            console.log(`Not posisiton for Marker #${index + 1}`)
            console.log(`lat: ${lat} Lon: ${lon}`)
            return
          }

          var pos = new google.maps.LatLng(marker.position)

          bounds.extend(pos)
        }
        catch (e) {
          console.log(e)
        }
      })

      this.map.fitBounds(bounds)
      this.map.setZoom(this.zoom)
    },
    /**
         *
         *
         */
    async fetchData () {
      this.isLoading = true
      this.$axios
        .get('/api/vehicle.json') // Adjust the path based on your setup
        .then((response) => {
          this.error = null
          this.isLoading = false

          this.vehicles = response.data

          this.initMap()

          this.plotVehicles(this.vehicles)

          this.zoomCoOrdinates()
        })
        .catch((err) => {
          this.isLoading = false
          this.error = 'Error fetching data: ' + err.message
          this.data = null
        })
    },

    async fetchLive () {
      let url = this.$baseUrl
      url += '/api/v2/vehicle'

      this.isLoading = true
      this.$axiosCache
        .get(url) // Adjust the path based on your setup
        .then((response) => {
          this.error = null
          this.isLoading = false

          this.vehicles = response.data

          this.initMap()

          this.plotVehicles(this.vehicles)

          this.zoomCoOrdinates()
        })
        .catch((err) => {
          this.isLoading = false
          this.error = 'Error fetching data: ' + err.message
          this.data = null
        })
    },

    plotVehicles (vehicles) {
      for (const veh of vehicles) {
        const advancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          content: this.buildContent(veh),
          position: { lat: veh.Latitude, lng: veh.Longitude },
          title: veh.RegNumber
        })

        advancedMarkerElement.addListener('gmp-click', () => {
          setTimeout(() => { this.togglehighlight(advancedMarkerElement, veh)
          }, 300)
        })

        this.markers.push(advancedMarkerElement)
      }
    },


    togglehighlight (markerView, property) {
      if (markerView.content.classList.contains('highlight-veh-marker-2026')) {
        markerView.content.classList.remove('highlight-veh-marker-2026')
        markerView.zIndex = null
      }
      else {
        markerView.content.classList.add('highlight-veh-marker-2026')
        markerView.zIndex = 1
      }
    },

    /**
       *   V 0.1.0 - 2022-10-03
       *       - Copied from GooogleMapsRoutines.js
       *
       */
    getElapsed (lastUpdate) {
      const lastTime = new Date(lastUpdate)
      const currTime = new Date()
      const elapsed = this.differenceInHours(currTime, lastTime)
      if (elapsed > TIME_AMBER_STATIONARY_HRS) {
        return true // this.TIME_AMBER_STATIONARY_HRS;
      }

      return false
    },

    /**
       *
       * @param {*} currTime
       * @param {*} lastTime
       *
       */
    differenceInHours (currTime, lastTime) {
      const diffInMs = currTime.getTime() - lastTime.getTime()
      const diffInHours = diffInMs / 3600000

      return diffInHours
    },

    buildContent (veh) {
      const unitID = veh.UnitID
      const regNumber = veh.RegNumber
      const unitModel2ID = veh.UnitModel2ID
      const vehicleId = veh.ID
      const Lat = veh.Latitude
      const Lng = veh.Longitude

      const lastUpdate = this.checkNull(veh.LastUpdate, 'date').replace('T', '  ')
      const infoSpeed = this.checkNull(veh.Speed, 'i')
      const driverNameDisplay = 'Driver: ' + this.checkNull(veh.DriverName, 'txt').replace('/', '  ')
      const driverName = this.checkNull(veh.DriverName, 'txt').replace('/', '  ')

      const vehCurrent = lastUpdate

      const vehDet = ` ${lastUpdate} ${infoSpeed} ${driverNameDisplay} `

      const vehicleDetails = `
     (${veh.UserVehicleColour}) ${veh.UserVehicleMake} - ${veh.UserVehicleModel}     `

      const content = document.createElement('div')
      content.classList.add('property-veh-marker-2026')

      let iconType = veh.IgnitionStatus === 0 ? 'car' : 'car-side'

      let elapsed = false
      if (this.getElapsed(veh.LastUpdate)) {
        iconType = 'wifi'
        elapsed = true
      }


      if (elapsed) {
        content.innerHTML = `
            <span class="icon ">
                <i aria-hidden="true" class="fas fa-${iconType} fa-stack-1x" ></i>
                <i aria-hidden="true" class="fas fa-slash fa-stack-1x" style="color: red;  "></i>
            </span>
        `
      }
      else {
        content.innerHTML = `
        <div class="icon">
            <i aria-hidden="true" class="fas fa-icon fa-${iconType}" ></i>
            <span class="fa-sr-only">${iconType}</span>
        </div>
        `
      }


      const tripButtonsHtml = `
           <div>

                    <span class="fa-stack">
                        <i class="fas fa-route fa-stack-1x"></i>

                    </span>
                    <a class="infoButton " href=" #/trip-list/${unitID}/${regNumber}/${driverName}/${vehicleId}">
                        <i class="fas fa-timeline "></i>
                        &nbsp;&nbsp;&nbsp;Trips&nbsp;&nbsp;&nbsp;
                    </a>

                    <a class="infoButton " href=" #/calendar-trips-select/${unitID}/${regNumber}/${driverName}/${vehicleId}">
                        <i class="mdi mdi-calendar-expand-horizontal "></i>
                        Calendar
                    </a>

                    <a class="infoButton " href=" #/day-navigator/${unitID}/${regNumber}/${driverName}/${vehicleId}">
                        <i class="mdi mdi-road-variant theme--light "></i>
                        Navigator
                    </a>
            </div>

      `


      content.innerHTML += `
    <div class="details" >
        <div class="price">${regNumber}</div>
        <div class="address">${vehicleDetails} </div>
        <div class="address">${driverNameDisplay} </div>
        <div class="address">${vehCurrent} </div>
        <div class="features">
            <div>
                <div>
                    <a class="infoButton "
                        href=" #/map-follow/${unitID}/${regNumber}/${driverName}/${vehicleId}/${Lat}/${Lng}">
                        <i class="fa-solid fa-location-crosshairs"></i>
                        &nbsp;&nbsp;Follow&nbsp;&nbsp;
                    </a>
                </div>
                ${this.tripButtons ? tripButtonsHtml : ''}

             </div>

    </div>
    `
      return content
    },

    formatThumbLabel (minutes) {
      const hrs = Math.floor(minutes / 60)
        .toString()
        .padStart(2, '0')
      const mins = (minutes % 60).toString().padStart(2, '0')
      return `${hrs}h ${mins}m`
    },

    formatDate (date) {
      return format(new Date(date), 'MMMM dd, yyyy')
    },

    formatTime (time) {
      return format(new Date(time), 'HH:mm')
    },

    /**
       *  V 0.1.0 - 2023-02-28
       *     - MOdified original as it was failing wiht val of undefined,
       *       the val need to be prefxied with typeof
       *
       * @param {*} val
       * @param {*} type
       */
    checkNull (val, type) {
      //
      switch (type) {
      case 'txt':
        if (typeof val === 'undefined') return ''
        return val
      case 'date':
        if (typeof val === 'undefined') {
          /*  */
          return '1970/01/01 00:00:01'
        }
        return val.toLocaleString()

      case 'dd':
        if (val == null) {
          return 0.0
        }
        return val

      case 'i':
        if (typeof val === 'undefined') return -1
        return val
      default:
        if (typeof val === 'undefined') return null
        return val
      }
    },

    isAppleDevice () {
      const userAgent = window.navigator.userAgent
      const platform = window.navigator.platform

      const iosPlatforms = ['iPhone', 'iPad', 'iPod']
      const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']

      var isApple = false
      var os = ''

      if (iosPlatforms.indexOf(platform) !== -1) {
        isApple = true
        os = 'iOS'
      } else if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'macOS'
        isApple = true
      } else {
        os = 'Unknown OS'
        isApple = false
      }

      this.$debug ? console.log(`isAppleDevice() ${isApple} = ${os} `) : null

      return isApple
    }

  }

}
</script>

<style>



    :root {
      --building-color: #ff9800;
      --house-color: #0288d1;
      --shop-color: #7b1fa2;
      --warehouse-color: #558b2f;
      /* */
      --car-side-color: #f40505;
      --car-color: #0288d1;
      --wifi-color: #ff9c09;
    }

    .marker-content {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 8px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    }


    /*
   * Optional: Makes the sample page fill the window.
   */

    /*
   * Always set the map height explicitly to define the size of the div element
   *
  *   that contains the map.
   */
    #map {
      height: 100%;
      width: 100%;
    }

    .map-container {
      height: 100vh;
      width: 100%;
    }


    /*
   * property-veh-marker-2026 styles in unhighlight-veh-marker-2026ed state.
   */
    .property-veh-marker-2026 {
      align-items: center;
      background-color: #ffffff;
      border-radius: 50%;
      color: #263238;
      display: flex;
      font-size: 19px !important;
      gap: 15px;
      height: 30px;
      justify-content: center;
      padding: 4px;
      position: relative;
      position: relative;
      transition: all 0.3s ease-out;
      width: 30px;
      transform: translateY(-9px);
    }

      .property-veh-marker-2026::after {
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-top: 9px solid #ffffff;
        content: '';
        height: 0;
        left: 50%;
        position: absolute;
        top: 95%;
        transform: translate(-50%, 0);
        transition: all 0.3s ease-out;
        width: 0;
        z-index: 1;
      }


      .property-veh-marker-2026 .icon {
        align-items: center;
        display: flex;
        justify-content: center;
        color: #ffffff;
      }


        .property-veh-marker-2026 .icon svg {
          height: 30px;
          width: auto;
        }

      /*
    2026-01-27  below was very important in getting correct operations
  */
      .property-veh-marker-2026 .details {
        display: none; /* making this none was mui importante because otherwise the deatils appeared on map without click */
        flex-direction: column;
        flex: 1;
        align-items: center;
      }

      .property-veh-marker-2026 .registration {
        color: #9e9e9e;
        font-size: 10px;
        margin-bottom: 10px;
        margin-top: 5px;
      }


      .property-veh-marker-2026 .address {
        color: #9e9e9e;
        font-size: 12px;
        margin-bottom: 2px;
        margin-top: 2px;
        align-items: center;
      }

      .property-veh-marker-2026 .features {
        align-items: flex-end;
        display: flex;
        flex-direction: column !important;
        gap: 10px;
      }

        .property-veh-marker-2026 .features > div {
          display: flex;
          flex-direction: column !important;
          ;
          /* */

          align-items: center;
          background: #f5f5f5;
          border-radius: 5px;
          border: 1px solid #ccc;
          display: flex;
          font-size: 10px;
          gap: 5px;
          padding: 5px;
        }

      /*
   * property-veh-marker-2026 styles in highlight-veh-marker-2026ed state.
   */
      .property-veh-marker-2026.highlight-veh-marker-2026 {
        display: flex;
        display: inline-table;
        /* */

        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.2);
        height: 80px;
        padding: 8px 15px;
        width: auto;
      }

        .property-veh-marker-2026.highlight-veh-marker-2026::after {
          display: flex;
          display: inline-table;
          /* */
          border-top: 9px solid #ffffff;
        }


        .property-veh-marker-2026.highlight-veh-marker-2026 .details {
          display: flex;
        }

        .property-veh-marker-2026.highlight-veh-marker-2026 .icon svg {
          width: 50px;
          height: 50px;
        }


      .property-veh-marker-2026 .size {
        color: #388e3c;
      }



      /*
   * Vechicle Moving icon colors.
   */
      .property-veh-marker-2026.highlight-veh-marker-2026:has(.fa-wifi) .icon {
        color: var(--wifi-color);
      }

      .property-veh-marker-2026:not(.highlight-veh-marker-2026):has(.fa-wifi) {
        background-color: var(--wifi-color);
      }

        .property-veh-marker-2026:not(.highlight-veh-marker-2026):has(.fa-wifi)::after {
          border-top: 9px solid var(--wifi-color);
        }



      /*
   * Car Colours .
   */
      .property-veh-marker-2026.highlight-veh-marker-2026:has(.fa-car) .icon {
        color: var(--car-color);
      }

      .property-veh-marker-2026:not(.highlight-veh-marker-2026):has(.fa-car) {
        background-color: var(--car-color);
      }

        .property-veh-marker-2026:not(.highlight-veh-marker-2026):has(.fa-car)::after {
          border-top: 9px solid var(--car-color);
        }



      /*
   * Vechicle Moving icon colors.
   * -----------------------------------------------------
   */
      .property-veh-marker-2026.highlight-veh-marker-2026:has(.fa-car-side) .icon {
        color: var(--car-side-color);
      }

      .property-veh-marker-2026:not(.highlight-veh-marker-2026):has(.fa-car-side) {
        background-color: var(--car-side-color);
      }

        .property-veh-marker-2026:not(.highlight-veh-marker-2026):has(.fa-car-side)::after {
          border-top: 9px solid var(--car-side-color);
        }



    /*
   // used for debugging.

  .property-veh-marker-2026:has(.fa-car) {
    outline: 2px solid red !important;
  }
  .property-veh-marker-2026:has(.fa-car-side) {
    outline: 2px solid blue !important;
  }
  .property-veh-marker-2026:has(.fa-wifi) {
    outline: 3px dashed lime !important;
  }
   */





</style>
